import { Component, OnInit } from '@angular/core';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { WindowScrollService } from 'src/app/services/window-scroll/window-scroll.service';
import { ScreenSizeService } from 'src/app/services/screen-size/screen-size.service';
import { EditModeService } from 'src/app/services/edit-mode/edit-mode.service';

@Component({
    selector: 'xqnr-suggestion-notify',
    templateUrl: './suggestion-notify.component.pug',
    styleUrls: ['./suggestion-notify.component.scss'],
    standalone: false
})
export class SuggestionNotifyComponent implements OnInit {
  fa = {
    bell: faBell
  };

  constructor(
    public suggestions: SuggestionService,
    private backdrop: BackdropService,
    private windowScroll: WindowScrollService,
    private screenSize: ScreenSizeService,
    public editMode: EditModeService
  ) {}

  ngOnInit(): void {}

  toggleSuggestions() {
    if (this.suggestions.active) {
      this.suggestions.hide();
      this.backdrop.hide();
      this.windowScroll.allowWindowScroll();

    } else {
      this.suggestions.show();
      this.backdrop.show();

      if (this.screenSize.lte(this.screenSize.sm)) {
        this.windowScroll.preventWindowScroll();
      }
    }
  }
}
